import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import jwt_decode from "jwt-decode";
// react-bootstrap components
import { Collapse, Nav } from "react-bootstrap";
import { useSelector } from "react-redux";
import defaultLogo from "../../assets/img/logo.png";

function Sidebar({ routes, background, users }) {
  let location = useLocation();
  const [state, setState] = React.useState({});
  const [currentUser, setCurrentUser] = useState(null);
  const settings = useSelector((state) => state.settings.settings);
  const [logoUrl, setLogoUrl] = useState(defaultLogo);
  const [logoError, setLogoError] = useState(false);

  // Get current user from localStorage on component mount
  React.useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      try {
        const user = JSON.parse(userData);
        setCurrentUser(user);
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  // Handle logo loading from settings
  React.useEffect(() => {
    if (settings && settings.logoUrl && !logoError) {
      setLogoUrl(settings.logoUrl);
    } else if (settings && settings.logo && !logoError) {
      const logoFullUrl = `${process.env.REACT_APP_BACK_BASEURL}${settings.logo}`;
      setLogoUrl(logoFullUrl);
    } else {
      setLogoUrl(defaultLogo);
    }
  }, [settings, logoError]);

  const handleLogoError = () => {
    console.warn("Failed to load company logo, using default");
    setLogoError(true);
    setLogoUrl(defaultLogo);
  };

  React.useEffect(() => {
    /* setState(getCollapseStates(routes)); */
  }, []);

  const getCollapseInitialState = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (location.pathname === routes[i].layout + routes[i].path) {
        return true;
      }
    }
    return false;
  };

  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      var st = {};
      //prop.id_role.includes(id_role)
      if (prop.id_role.includes(currentUser?.role)) {
        if (prop.redirect) {
          return null;
        }
        if (prop.collapse) {
          st[prop["state"]] = !state[prop.state];
          return (
            <Nav.Item
              className={getCollapseInitialState(prop.views) ? "active" : ""}
              as="li"
              key={key}
            >
              <Nav.Link
                className={state[prop.state] ? "collapsed" : ""}
                data-toggle="collapse"
                onClick={(e) => {
                  e.preventDefault();
                  setState({ ...state, ...st });
                }}
                aria-expanded={state[prop.state]}
              >
                <i className={prop.icon}></i>
                <p>
                  {prop.name} <b className="caret"></b>
                </p>
              </Nav.Link>
              <Collapse in={state[prop.state]}>
                <div>
                  <Nav as="ul">{createLinks(prop.views)}</Nav>
                </div>
              </Collapse>
            </Nav.Item>
          );
        }
        return (
          <Nav.Item className={activeRoute(prop.path)} key={key} as="li">
            {/* {getTitle(prop.path, prop.name)} */}
            <Nav.Link className={prop.className} to={prop.path} as={Link}>
              {prop.icon ? (
                <>
                  <i className={prop.icon} />
                  <p>{prop.name}</p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini">{prop.mini}</span>
                  <span className="sidebar-normal">{prop.name}</span>
                </>
              )}
            </Nav.Link>
          </Nav.Item>
        );
      } else {
        return null;
      }
    });
  };

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };

  function getTitle(routeName, name) {
    if (location.pathname.toUpperCase() === routeName.toUpperCase()) {
      if (routeName !== "/telechargerFichier/:id/:idBl") {
        localStorage.removeItem("file");
        localStorage.removeItem("returnList");
      }
      if (routeName !== "/ajouterProduit") {
        localStorage.removeItem("nomProd");
        localStorage.removeItem("idProd");
      }
      document.title = name;
      //return location.pathname === routeName ? routeName : "";
    }
  }

  return (
    <>
      <div className="sidebar" data-color={background}>
        <div className="sidebar-wrapper">
          <div className="logo">
            <div className="bglogo">
              <img
                src={logoUrl}
                alt={settings?.companyName || "Company Logo"}
                onError={handleLogoError}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  maxHeight: "60px",
                  objectFit: "contain",
                }}
              />
            </div>
            {/* Optional: Display company name below logo */}
            {/* {settings?.companyName && (
              <div
                className="company-name"
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  fontSize: "12px",
                  fontWeight: "bold",
                  color: "#333",
                }}
              >
                {settings.companyName}
              </div>
            )} */}
          </div>

          <Nav as="ul">{createLinks(routes)}</Nav>
        </div>
      </div>
    </>
  );
}

Sidebar.defaultProps = {
  image: "",
  background: "black",
  routes: [],
};

export default Sidebar;
